var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { availableHippodromes, availableLongtermHippodromes, availableRuns, tjkBetSlipActionSubject, tjkBetSlipOptions, tjkOrderedBetTypes, tjkSingleLegBetTypes, tjkSortedBetTypes, tjkFobBettingTypes, tjkFobHorseSelectionTypes, tjkLongtermBettingTypes, } from './tjk.store';
import { tjkBetslipStore } from './components/tjk.betslip';
import { modalServiceSubject } from '../../components/modal/modal';
import { ApiService } from '../../lib/http.service';
import { Storage } from '../../lib/localstorege.service';
import { isAndroid, isIOS, isMacOs, isMobile, isWindows, } from 'react-device-detect';
import { env } from '../../definitions/global.vars';
import _ from 'lodash';
export var updateBetCount = { status: true };
var api = new ApiService();
export function addToTJKBetSlip(column, run, horse, action) {
    var _b, _c, _d;
    if (action === void 0) { action = 'toggle'; }
    if (env.tjk === false)
        return;
    updateBetCount.status = true;
    if (tjkBetSlipOptions.inProgress === true) {
        modalServiceSubject.next({
            title: 'Uyarı',
            content: 'Bahisleriniz işleniyor. Lütfen bekleyiniz.',
            timeout: 3000,
            confirm: {
                cancel: {
                    label: 'Tamam',
                },
            },
        });
        return;
    }
    if (horse.run_status === false)
        return;
    var horseNo = Number(horse.no);
    if (tjkBetSlipOptions.bettingType.id.toString() === '1886') {
        horseNo = horse.no.toString() + 'T2';
    }
    else if (tjkBetSlipOptions.bettingType.id.toString() === '1887') {
        horseNo = horse.no.toString() + 'T3';
    }
    else if (tjkBetSlipOptions.bettingType.id.toString() === '1888') {
        horseNo = horse.no.toString() + 'T4';
    }
    if (tjkFobBettingTypes.includes(Number((_b = tjkBetSlipOptions.bettingType) === null || _b === void 0 ? void 0 : _b.id))) {
        if (((_d = (_c = run.event_odds) === null || _c === void 0 ? void 0 : _c[horseNo]) === null || _d === void 0 ? void 0 : _d.status) !== "o") {
            return;
        }
    }
    var horseIndex = isAdded(column, run, horse);
    if (horseIndex === false &&
        tjkBetSlipOptions.bettingType &&
        tjkFobHorseSelectionTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) {
        var idx = tjkBetslipStore.findIndex(function (el) {
            return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                el.horse.no === horse.no &&
                el.run.no === run.no &&
                el.bettingType.id === tjkBetSlipOptions.bettingType.id &&
                String(el.bettingSubType) === String(tjkBetSlipOptions.bettingSubType);
        });
        if (idx !== -1)
            horseIndex = idx;
    }
    var subjectAction = '';
    if (horseIndex === false && (action === 'toggle' || action === 'add')) {
        if (tjkBetSlipOptions.bettingType &&
            tjkFobBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) {
            var fobTypeId_1 = Number(tjkBetSlipOptions.bettingType.id);
            // Her FOB tipi için: aynı koşuda farklı bahis türü varsa uyar ve temizle
            var diffTypeItems = tjkBetslipStore.filter(function (el) {
                return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                    tjkFobBettingTypes.includes(Number(el.bettingType.id)) &&
                    el.run.no === run.no &&
                    Number(el.bettingType.id) !== fobTypeId_1;
            });
            if (diffTypeItems.length > 0) {
                modalServiceSubject.next({
                    title: 'Uyarı',
                    content: 'Biletinizde aynı koşuda farklı bahis türünden at mevcut. Bahisleriniz güncellenecektir.',
                    timeout: 3000,
                    confirm: { cancel: { label: 'Tamam' } },
                });
                for (var _i = 0, diffTypeItems_1 = diffTypeItems; _i < diffTypeItems_1.length; _i++) {
                    var item = diffTypeItems_1[_i];
                    var idx = tjkBetslipStore.indexOf(item);
                    if (idx !== -1)
                        tjkBetslipStore.splice(idx, 1);
                }
            }
            if (tjkFobHorseSelectionTypes.includes(fobTypeId_1)) {
                // Exacta (1884/1885): aynı at zaten seçiliyse reddet
                var sameHorseIdx = tjkBetslipStore.findIndex(function (el) {
                    return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                        el.bettingType.id === fobTypeId_1 &&
                        el.run.no === run.no &&
                        String(el.horse.no) === String(horse.no);
                });
                if (sameHorseIdx !== -1) {
                    modalServiceSubject.next({
                        title: 'Uyarı',
                        content: 'İkili bahis tipinde aynı atları seçemezsiniz.',
                        timeout: 3000,
                        confirm: { cancel: { label: 'Tamam' } },
                    });
                    return;
                }
                // (1884/1885): bu koşu için en fazla 2 at seçilebilir
                var selectedCount = tjkBetslipStore.filter(function (el) {
                    return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                        el.bettingType.id === fobTypeId_1 &&
                        el.run.no === run.no;
                }).length;
                if (selectedCount >= 2) {
                    modalServiceSubject.next({
                        title: 'Uyarı',
                        content: 'İkili bahis tipinde en fazla 2 at seçebilirsiniz.',
                        timeout: 3000,
                        confirm: { cancel: { label: 'Tamam' } },
                    });
                    return;
                }
                // First horse → column 1, second horse → column 2
                column = selectedCount === 0 ? 1 : 2;
                if (fobTypeId_1 === 1884 && selectedCount === 1) {
                    var existingIdx = tjkBetslipStore.findIndex(function (el) {
                        return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                            el.bettingType.id === fobTypeId_1 &&
                            el.run.no === run.no;
                    });
                    if (existingIdx !== -1) {
                        if (Number(horse.no) < Number(tjkBetslipStore[existingIdx].horse.no)) {
                            tjkBetslipStore[existingIdx].column = 2;
                            column = 1;
                        }
                        else {
                            tjkBetslipStore[existingIdx].column = 1;
                            column = 2;
                        }
                    }
                }
            }
            else {
                // Non-exacta FOB: aynı koşudaki aynı tip seçimi değiştir
                var existingIdx = tjkBetslipStore.findIndex(function (el) {
                    return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                        Number(el.bettingType.id) === fobTypeId_1 &&
                        el.run.no === run.no;
                });
                if (existingIdx !== -1) {
                    tjkBetslipStore.splice(existingIdx, 1);
                }
            }
            // 7-horse limit: count unique hippodrome+run combinations across all FOB items
            var fobSlipItems = tjkBetslipStore.filter(function (el) {
                return tjkFobBettingTypes.includes(Number(el.bettingType.id));
            });
            var groupedItems = _.groupBy(fobSlipItems, function (item) { return "".concat(item.hippodrome.id, "-").concat(item.run.no); });
            var currentGroupKey = "".concat(tjkBetSlipOptions.hippodrome.id, "-").concat(run.no);
            if (Object.keys(groupedItems).length >= 7 &&
                !groupedItems[currentGroupKey]) {
                modalServiceSubject.next({
                    title: 'Uyarı',
                    content: 'Sabit ihtimalli bahislerde en fazla 7 at seçebilirsiniz.',
                    timeout: 3000,
                    confirm: { cancel: { label: 'Tamam' } },
                });
                return;
            }
        }
        tjkBetslipStore.push({
            hippodrome: tjkBetSlipOptions.hippodrome,
            bettingType: tjkBetSlipOptions.bettingType,
            bettingSubType: tjkBetSlipOptions.bettingSubType,
            column: column,
            run: run,
            horse: horse,
        });
        subjectAction = 'add';
    }
    else if (horseIndex !== false && (action === 'toggle' || action === 'remove')) {
        subjectAction = 'remove';
        tjkBetslipStore.splice(horseIndex, 1);
    }
    if (action === 'toggle') {
        tjkBetSlipActionSubject.next({
            action: subjectAction,
            column: column,
            run: run,
            horse: horse,
        });
    }
}
export function addToTjkLongtermBetSlip(hippodrome, horse, action) {
    var _b;
    if (action === void 0) { action = 'toggle'; }
    if (env.tjk === false)
        return;
    if (tjkBetSlipOptions.inProgress === true) {
        modalServiceSubject.next({
            title: 'Uyarı',
            content: 'Bahisleriniz işleniyor. Lütfen bekleyiniz.',
            timeout: 3000,
            confirm: {
                cancel: {
                    label: 'Tamam',
                },
            },
        });
        return;
    }
    if (Number(hippodrome.status) !== 1 && hippodrome.status !== true)
        return;
    if (horse.status !== 'o')
        return;
    updateBetCount.status = true;
    var horseIndex = isAddedLongterm(hippodrome, horse);
    var subjectAction = '';
    if (horseIndex === false && (action === 'toggle' || action === 'add')) {
        for (var i = tjkBetslipStore.length - 1; i >= 0; i--) {
            if (tjkLongtermBettingTypes.includes(Number((_b = tjkBetslipStore[i].bettingType) === null || _b === void 0 ? void 0 : _b.id))) {
                tjkBetslipStore.splice(i, 1);
            }
        }
        tjkBetslipStore.push({
            hippodrome: hippodrome,
            bettingType: tjkBetSlipOptions.bettingType,
            bettingSubType: tjkBetSlipOptions.bettingSubType,
            column: 1,
            horse: horse,
        });
        subjectAction = 'add';
    }
    else if (horseIndex !== false && (action === 'toggle' || action === 'remove')) {
        subjectAction = 'remove';
        tjkBetslipStore.splice(horseIndex, 1);
    }
    if (action === 'toggle') {
        tjkBetSlipActionSubject.next({ action: subjectAction, horse: horse });
    }
}
export function isAdded(column, run, horse) {
    if (!run || !horse || !tjkBetSlipOptions.hippodrome)
        return false;
    var horseIndex = tjkBetslipStore.findIndex(function (el) {
        return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            el.horse.no === horse.no &&
            el.run.no === run.no &&
            el.bettingType === tjkBetSlipOptions.bettingType &&
            String(el.bettingSubType) === String(tjkBetSlipOptions.bettingSubType) &&
            el.column === column;
    });
    return horseIndex === -1 ? false : horseIndex;
}
export function isAddedAll(column, run) {
    if (!run || !tjkBetSlipOptions.hippodrome)
        return false;
    var status = tjkBetslipStore.filter(function (el) {
        return (el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            el.bettingType === tjkBetSlipOptions.bettingType &&
            el.bettingSubType === tjkBetSlipOptions.bettingSubType &&
            el.column === column &&
            el.run.no === run.no);
    }).length === run.horses.filter(function (h) { return h.run_status === true; }).length
        ? true
        : false;
    return status;
}
export function isAddedLongterm(hippodrome, horse) {
    var horseIndex = tjkBetslipStore.findIndex(function (el) {
        var _b;
        return tjkLongtermBettingTypes.includes(Number((_b = el.bettingType) === null || _b === void 0 ? void 0 : _b.id)) &&
            el.hippodrome.id === hippodrome.id &&
            Number(el.horse.no) === Number(horse.no);
    });
    return horseIndex === -1 ? false : horseIndex;
}
export function setTjkBetSlipMultiply(multiply) {
    // if(multiply!=='') {
    //   let validValue = Number(multiply) > 0 ? Number(multiply) : 1;
    //   const betCount = getbetCount();
    //   const totalAmount = validValue * betCount * tjkBetSlipOptions.bettingType.price;
    //
    //   if (totalAmount > 5000) {
    //     validValue = Math.floor(5000 / betCount)
    //     validValue = validValue > 0 ? validValue : multiply;
    //     tjkBetSlipOptions.errorMessage = 'Toplam bahis tutarı 5000 TL\'yi geçemez.';
    //     tjkBetSlipOptions.betSlipMultiply = validValue
    //   }else{
    //     validValue = multiply;
    //     tjkBetSlipOptions.betSlipMultiply = multiply
    //     tjkBetSlipOptions.errorMessage = null;
    //   }
    //
    // }else{
    //   tjkBetSlipOptions.betSlipMultiply = ''
    // }
    tjkBetSlipOptions.errorMessage = null;
    tjkBetSlipOptions.betSlipMultiply = multiply;
    tjkBetSlipActionSubject.next();
}
export function setTjkBetSlipMaxAmount(amount) {
    updateBetCount.status = true;
    if (amount !== '') {
        tjkBetSlipOptions.maxAmount = Number(amount) > 0 ? Number(amount) : 1;
    }
    else {
        tjkBetSlipOptions.maxAmount = '';
    }
    tjkBetSlipActionSubject.next();
}
export function compareUpdatesAndHorses() {
    // for(let hippodrome of DailyRaces){
    //
    //   for(let run of hippodrome.runs){
    //
    //     for(let horse of run.horses){
    //
    //       tjkBetslipStore.filter()
    //
    //     }
    //
    //   }
    //
    // }
    // closed hippodromes
    var mustRemoveHippodromes = tjkBetslipStore.filter(function (s) {
        if (tjkLongtermBettingTypes.includes(Number(s.bettingType.id)))
            return false;
        return !availableHippodromes.map(function (h) { return h.id; }).includes(s.hippodrome.id);
    });
    removeItemsFromCart(mustRemoveHippodromes);
    // closed runs
    var mustRemoveRuns = tjkBetslipStore.filter(function (s) {
        var _b;
        if (tjkLongtermBettingTypes.includes(Number(s.bettingType.id)))
            return false;
        if (!tjkBetSlipOptions.hippodrome || s.hippodrome.id !== tjkBetSlipOptions.hippodrome.id)
            return false;
        if (tjkFobBettingTypes.includes(Number(s.bettingType.id))) {
            // FOB öğeleri için: yeni bahis türünde koşu yoksa değil,
            // koşu gerçekten kapandıysa temizle
            var run = (_b = s.hippodrome.runs) === null || _b === void 0 ? void 0 : _b.find(function (r) { return r.no === s.run.no; });
            return !run || run.status !== 0;
        }
        return !availableRuns.map(function (h) { return h.no; }).includes(s.run.no);
    });
    removeItemsFromCart(mustRemoveRuns);
    // Kosmaz at
    var mustRemoveHorse = tjkBetslipStore.filter(function (s) {
        return !tjkLongtermBettingTypes.includes(Number(s.bettingType.id)) &&
            tjkBetSlipOptions.hippodrome &&
            s.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            s.horse.run_status === false;
    });
    removeItemsFromCart(mustRemoveHorse);
    // uzun vadeli: hipodrom veya seçim artık mevcut/aktif değilse temizle
    var mustRemoveLongterm = tjkBetslipStore.filter(function (s) {
        var _b;
        if (!tjkLongtermBettingTypes.includes(Number(s.bettingType.id)))
            return false;
        var hippodrome = availableLongtermHippodromes.find(function (h) { return h.id === s.hippodrome.id; });
        var odd = (_b = hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.event_odds) === null || _b === void 0 ? void 0 : _b[Number(s.horse.no)];
        return !odd || odd.status !== 'o';
    });
    removeItemsFromCart(mustRemoveLongterm);
    tjkBetSlipActionSubject.next();
}
function removeItemsFromCart(mustRemoveItem) {
    var _loop_1 = function (item) {
        tjkBetslipStore.splice(tjkBetslipStore.findIndex(function (i) {
            return i.hippodrome.id == item.hippodrome.id &&
                i.bettingType.id == item.bettingType.id &&
                i.bettingSubType == item.bettingSubType &&
                i.column == item.column;
        }), 1);
    };
    for (var _i = 0, mustRemoveItem_1 = mustRemoveItem; _i < mustRemoveItem_1.length; _i++) {
        var item = mustRemoveItem_1[_i];
        _loop_1(item);
    }
}
export function setTjkUsePointBalance(value) {
    if (tjkBetSlipOptions.errorMessage === 'Bakiyeniz yetersiz.') {
        tjkBetSlipOptions.errorMessage = null;
    }
    tjkBetSlipOptions.usePointBalance = value;
    tjkBetSlipActionSubject.next();
}
export function setTjkComplete(value) {
    tjkBetSlipOptions.complete = value;
    updateBetCount.status = true;
    tjkBetSlipActionSubject.next();
}
export function getCouponLegs() {
    // fixme gereksiz iki defa çalışıyor
    var slipItem = _.orderBy(tjkBetslipStore.filter(function (el) {
        if (el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            el.bettingType.id === tjkBetSlipOptions.bettingType.id &&
            el.bettingSubType === tjkBetSlipOptions.bettingSubType) {
            return el;
        }
    }), ['column']);
    var uniqueColumn = __spreadArray([], Array.from(new Set(slipItem.map(function (i) { return i.column; }))), true);
    var legs = [];
    var _loop_2 = function (c) {
        var cItems = slipItem
            .filter(function (i) { return i.column === c; })
            .map(function (el) { return (el.horse !== 's' ? el.horse.no : 's'); });
        legs.push(cItems);
    };
    for (var _i = 0, uniqueColumn_1 = uniqueColumn; _i < uniqueColumn_1.length; _i++) {
        var c = uniqueColumn_1[_i];
        _loop_2(c);
    }
    return legs;
}
var Combinatorics = require('js-combinatorics/combinatorics.js');
function getC(ix, sysCols) {
    var cR = 1;
    for (var _i = 0, sysCols_1 = sysCols; _i < sysCols_1.length; _i++) {
        var c = sysCols_1[_i];
        cR = 1;
        for (var _b = 0, _c = _.range(Number(c.s), Number(c.h) + 1); _b < _c.length; _b++) {
            var j = _c[_b];
            var bs = ix * j;
            if (bs * tjkBetSlipOptions.bettingType.price <=
                Number(tjkBetSlipOptions.maxAmount)) {
                cR = j;
            }
        }
        ix *= cR;
    }
    return ix;
}
function getCombinations(chars, n) {
    if (n === void 0) { n = 3; }
    var result = [];
    var f = function (prefix, chars) {
        for (var i = 0; i < chars.length; i++) {
            if (prefix.length === n - 1) {
                result.push(prefix.concat(chars[i]));
            }
            f(prefix.concat(chars[i]), chars.slice(i + 1));
        }
    };
    f([], chars);
    return result;
}
function choose(arr, k, prefix) {
    if (prefix === void 0) { prefix = []; }
    if (k == 0)
        return [prefix];
    return arr.flatMap(function (v, i) {
        return choose(arr.slice(i + 1), k - 1, __spreadArray(__spreadArray([], prefix, true), [v], false));
    });
}
export function getbetCount2() {
    // Kombine (1883): her zaman 1 kupon
    // Uzun vadeli (1889): her zaman 1 kupon
    if (tjkBetSlipOptions.bettingType &&
        (Number(tjkBetSlipOptions.bettingType.id) === 1883 || Number(tjkBetSlipOptions.bettingType.id) === 1889)) {
        return tjkBetslipStore.filter(function (el) { return el.bettingType.id === 1883; })
            .length > 0
            ? 1
            : 0;
    }
    var columnCount = 1;
    var slipItem = tjkBetslipStore.filter(function (el) {
        if (el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            el.bettingType.id === tjkBetSlipOptions.bettingType.id &&
            el.bettingSubType === tjkBetSlipOptions.bettingSubType) {
            return el;
        }
    });
    var uniqueColumn = __spreadArray([], Array.from(new Set(slipItem.map(function (i) { return i.column; }))), true);
    var minBetCount = 1;
    var minAvailableBetCount = 1;
    var maxAvailableBetCount = 1;
    var bankoCols = [];
    var allCols = [];
    var sysCols = [];
    var _loop_3 = function (c) {
        var cItems = slipItem
            .filter(function (i) { return i.column === c; })
            .map(function (el) { return (el.horse === 's' ? 's' : el.horse.no); });
        if (cItems.indexOf('s') !== -1) {
            var horseCount = slipItem
                .filter(function (i) { return i.column === c; })[0]
                .run.horses.filter(function (h) { return h.run_status === true; }).length;
            columnCount *= horseCount;
            minBetCount *= cItems.length;
            allCols.push({ c: c, s: cItems.length - 1 });
            sysCols.push({ c: c, s: cItems.length - 1, h: horseCount });
        }
        else {
            columnCount *= cItems.length;
            minBetCount *= cItems.length;
            allCols.push({ c: c, s: cItems.length });
            bankoCols.push({ c: c, s: cItems.length });
        }
    };
    for (var _i = 0, uniqueColumn_2 = uniqueColumn; _i < uniqueColumn_2.length; _i++) {
        var c = uniqueColumn_2[_i];
        _loop_3(c);
    }
    if (tjkBetSlipOptions.bettingType &&
        tjkBetSlipOptions.bettingType.column === uniqueColumn.length) {
        var ix = 1;
        for (var _b = 0, bankoCols_1 = bankoCols; _b < bankoCols_1.length; _b++) {
            var c = bankoCols_1[_b];
            ix *= c.s;
        }
        minAvailableBetCount = getC(ix, sysCols);
        maxAvailableBetCount = getC(ix, sysCols.reverse());
        var betCounts = [minAvailableBetCount, maxAvailableBetCount].sort();
        if (sysCols.length > 0) {
            tjkBetSlipOptions.system = true;
            tjkBetSlipOptions.systemMaxMin = betCounts;
            columnCount = maxAvailableBetCount;
        }
        else {
            tjkBetSlipOptions.system = false;
            tjkBetSlipOptions.systemMaxMin = null;
        }
    }
    // sıralı ikili combinasyon hesabı
    if (tjkBetSlipOptions.bettingType &&
        (tjkBetSlipOptions.bettingType.id === 56 ||
            tjkOrderedBetTypes.includes(tjkBetSlipOptions.bettingType.id) ||
            tjkSortedBetTypes.includes(tjkBetSlipOptions.bettingType.id))) {
        var legs_1 = [];
        var _loop_4 = function (c) {
            var cItems = slipItem
                .filter(function (i) { return i.column === c; })
                .map(function (el) { return el.horse.no; });
            legs_1.push(cItems);
        };
        for (var _c = 0, uniqueColumn_3 = uniqueColumn; _c < uniqueColumn_3.length; _c++) {
            var c = uniqueColumn_3[_c];
            _loop_4(c);
        }
        if (tjkBetSlipOptions.bettingType.id === 50 &&
            tjkBetSlipOptions.complete === true &&
            legs_1.length > 0) {
            legs_1.push(legs_1[0]);
        }
        if (tjkBetSlipOptions.bettingType.id === 53 &&
            tjkBetSlipOptions.complete === true &&
            legs_1.length > 0) {
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
        }
        if (tjkBetSlipOptions.bettingType.id === 56 &&
            tjkBetSlipOptions.complete === true &&
            legs_1.length > 0) {
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
        }
        if (tjkBetSlipOptions.bettingType.id === 63 &&
            tjkBetSlipOptions.complete === true &&
            legs_1.length > 0) {
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
            legs_1.push(legs_1[0]);
        }
        if (legs_1.length === 2) {
            var combinations_1 = legs_1[0]
                .flatMap(function (d) {
                return legs_1[1].map(function (v) {
                    if (d !== v) {
                        return d + '-' + v;
                    }
                    return null;
                });
            })
                .filter(function (e) { return e !== null; });
            columnCount = combinations_1.length;
            // ikili kombinasyonlarda aynı kombinasyonun tersi varsa çıkar
            if (tjkBetSlipOptions.bettingType.id === 10 ||
                tjkBetSlipOptions.bettingType.id === 47 ||
                tjkBetSlipOptions.bettingType.id === 50) {
                columnCount -=
                    combinations_1.filter(function (e) {
                        return combinations_1.includes(e.split('-')[1] + '-' + e.split('-')[0]);
                    }).length / 2;
            }
            if (tjkBetSlipOptions.bettingType.id !== 50 &&
                tjkBetSlipOptions.complete === true) {
                columnCount *= 2;
            }
        }
        else if (legs_1.length === 3) {
            var permu = [[0, 1, 2]];
            if (tjkBetSlipOptions.complete === true) {
                var pers = [];
                var tmp = Combinatorics.permutation([0, 1, 2], 3);
                var _a = tmp.next();
                while (_a) {
                    pers.push(_a);
                    _a = tmp.next();
                }
                permu = pers;
            }
            var allCombinations = [];
            var _loop_5 = function (_r) {
                var combinations = legs_1[_r[0]]
                    .flatMap(function (d) {
                    return legs_1[_r[1]].map(function (v) {
                        if (d !== v) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                combinations = combinations
                    .flatMap(function (d) {
                    return legs_1[_r[2]].map(function (v) {
                        if (d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                allCombinations.push.apply(allCombinations, combinations);
            };
            for (var _d = 0, permu_1 = permu; _d < permu_1.length; _d++) {
                var _r = permu_1[_d];
                _loop_5(_r);
            }
            columnCount = Array.from(new Set(allCombinations)).length;
        }
        else if (legs_1.length === 5) {
            var permu = [[0, 1, 2, 3, 4]];
            if (tjkBetSlipOptions.complete === true) {
                var pers = [];
                var tmp = Combinatorics.permutation([0, 1, 2, 3, 4], 5);
                var _a = tmp.next();
                while (_a) {
                    pers.push(_a);
                    _a = tmp.next();
                }
                permu = pers;
            }
            var allCombinations = [];
            var _loop_6 = function (_r) {
                var combinations = legs_1[_r[0]]
                    .flatMap(function (d) {
                    return legs_1[_r[1]].map(function (v) {
                        if (d !== v) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .flatMap(function (d) {
                    return legs_1[_r[2]].map(function (v) {
                        if (d && d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .flatMap(function (d) {
                    return legs_1[_r[3]].map(function (v) {
                        if (d && d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .flatMap(function (d) {
                    return legs_1[_r[4]].map(function (v) {
                        if (d && d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                allCombinations.push.apply(allCombinations, combinations);
            };
            for (var _e = 0, permu_2 = permu; _e < permu_2.length; _e++) {
                var _r = permu_2[_e];
                _loop_6(_r);
            }
            columnCount = Array.from(new Set(allCombinations)).length;
        }
        else {
            columnCount = 0;
        }
    }
    // Tabela Bahis
    if ((tjkBetSlipOptions.bettingType &&
        tjkBetSlipOptions.bettingType.id === 54) ||
        tjkBetSlipOptions.bettingType.id === 56) {
        var legs_2 = [];
        var _loop_7 = function (c) {
            var cItems = slipItem
                .filter(function (i) { return i.column === c; })
                .map(function (el) { return el.horse.no; });
            legs_2.push(cItems);
        };
        for (var _f = 0, uniqueColumn_4 = uniqueColumn; _f < uniqueColumn_4.length; _f++) {
            var c = uniqueColumn_4[_f];
            _loop_7(c);
        }
        if (tjkBetSlipOptions.bettingType.id === 56 && legs_2.length > 0) {
            legs_2.push(legs_2[0]);
            legs_2.push(legs_2[0]);
            legs_2.push(legs_2[0]);
        }
        if (legs_2.length === 4) {
            var permu = [[0, 1, 2, 3]];
            if (tjkBetSlipOptions.complete === true) {
                var pers = [];
                var tmp = Combinatorics.permutation([0, 1, 2, 3], 4);
                var _a = tmp.next();
                while (_a) {
                    pers.push(_a);
                    _a = tmp.next();
                }
                permu = pers;
            }
            var allCombinations = [];
            var _loop_8 = function (_r) {
                var combinations = legs_2[_r[0]]
                    .flatMap(function (d) {
                    return legs_2[_r[1]].map(function (v) {
                        if (d !== v) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                combinations = combinations
                    .flatMap(function (d) {
                    return legs_2[_r[2]].map(function (v) {
                        if (d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                combinations = combinations
                    .flatMap(function (d) {
                    return legs_2[_r[3]].map(function (v) {
                        if (d.split('-').indexOf(v) === -1) {
                            return d + '-' + v;
                        }
                        return null;
                    });
                })
                    .filter(function (e) { return e !== null; });
                allCombinations.push.apply(allCombinations, combinations);
            };
            for (var _g = 0, permu_3 = permu; _g < permu_3.length; _g++) {
                var _r = permu_3[_g];
                _loop_8(_r);
            }
            columnCount = Array.from(new Set(allCombinations)).length;
        }
    }
    // Virgullu combinasyon hesabı
    if (tjkBetSlipOptions.bettingType &&
        (tjkSortedBetTypes.includes(tjkBetSlipOptions.bettingType.id) ||
            tjkBetSlipOptions.bettingType.id === 56)) {
        if (tjkBetSlipOptions.complete !== true) {
            columnCount = Combinatorics.C(slipItem.length, tjkBetSlipOptions.bettingType.horseCount);
        }
        if (tjkBetSlipOptions.complete === true) {
            if (tjkBetSlipOptions.bettingType.id === 50) {
                columnCount *= 2;
            }
            else if (tjkBetSlipOptions.bettingType.id === 53) {
                return columnCount;
            }
            else if (tjkBetSlipOptions.bettingType.id === 56) {
                return columnCount;
            }
        }
        return columnCount;
    }
    // Tek Kolonlu combinasyon hesabı
    if (tjkBetSlipOptions.bettingType &&
        tjkSingleLegBetTypes.includes(tjkBetSlipOptions.bettingType.id)) {
        return Combinatorics.C(slipItem.length, 2);
    }
    // Ganyan ve Plasede betcount 2 kat hesaplanıyor
    if (tjkBetSlipOptions.bettingType && tjkBetSlipOptions.bettingType.id === 4) {
        columnCount *= 2;
    }
    // FOB exacta (1884/1885): 2 horses selected but they form a single combined coupon
    if (tjkBetSlipOptions.bettingType &&
        tjkFobHorseSelectionTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) {
        return slipItem.length === 2 ? 1 : 0;
    }
    return tjkBetSlipOptions.bettingType &&
        tjkBetSlipOptions.bettingType.column === uniqueColumn.length
        ? columnCount
        : 0;
}
var memoBetCount = 0;
export function getbetCount() {
    if (updateBetCount.status) {
        memoBetCount = getbetCount2();
        updateBetCount.status = false;
    }
    return memoBetCount;
}
function getCouponLegsFromSlipItem(slipItems) {
    var legs = [];
    for (var _i = 0, slipItems_1 = slipItems; _i < slipItems_1.length; _i++) {
        var item = slipItems_1[_i];
        var legObj = {};
        var hippodrome = item.hippodrome;
        // const _date = hippodrome.date ? hippodrome.date.split('T')[0] : ''
        var _date = hippodrome._date;
        var keyword = hippodrome.keyword ? hippodrome.keyword.toLowerCase() : '';
        var runNo = item.run.no;
        var betType = item.bettingType.id;
        var horseName = String(item.horse.no);
        // if (Number(item.bettingType.id) === 1886) horseName += 'T2'
        // else if (Number(item.bettingType.id) === 1887) horseName += 'T3'
        // else if (Number(item.bettingType.id) === 1888) horseName += 'T4'
        legObj["".concat(_date, "-").concat(keyword, "_").concat(runNo, "_").concat(betType)] = [horseName];
        legs.push(legObj);
    }
    // FOB: İkili/Sıralı İkili (1184/1885)'de iki atı tek keyde birleştiriyoruz
    var merged = Object.entries(legs.reduce(function (acc, item) {
        Object.entries(item).forEach(function (_b) {
            var key = _b[0], values = _b[1];
            if (acc[key]) {
                acc[key] = __spreadArray(__spreadArray([], acc[key].map(Number), true), values.map(Number), true);
            }
            else {
                acc[key] = __spreadArray([], values, true);
            }
        });
        return acc;
    }, {})).map(function (_b) {
        var _c;
        var key = _b[0], value = _b[1];
        return (_c = {}, _c[key] = value, _c);
    });
    return merged;
}
export function PlayTjkFobCoupon(save) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    if (save === void 0) { save = false; }
    return __awaiter(this, void 0, void 0, function () {
        var orderUrl, deviceOs, slipItems, exactaGroups, incompleteExacta, price, couponData, hippodrome, isExactaPair, runNo_1, run, oddKey, oddId, horseLegs, oddIds, _loop_9, i, slipItem, runNo_2, run, horseNo, typeId, oddKey, oddEntry, isKO;
        return __generator(this, function (_2) {
            switch (_2.label) {
                case 0:
                    orderUrl = env.tjk_api + '/order/api/tjk/place-order/';
                    deviceOs = isAndroid
                        ? 'Android'
                        : isIOS
                            ? 'iOS'
                            : isMacOs
                                ? 'Macintosh'
                                : isWindows
                                    ? 'Windows'
                                    : 'Linux';
                    updateBetCount.status = true;
                    slipItems = tjkBetslipStore.filter(function (el) {
                        return tjkFobBettingTypes.includes(Number(el.bettingType.id));
                    });
                    if (slipItems.length === 0)
                        return [2 /*return*/, null
                            // İkili/Sıralı İkili (1884/1885): her grup tam 2 at içermeli
                        ];
                    exactaGroups = _.groupBy(slipItems.filter(function (el) {
                        return tjkFobHorseSelectionTypes.includes(Number(el.bettingType.id));
                    }), function (el) { return "".concat(el.hippodrome.id, "-").concat(el.bettingType.id, "-").concat(el.run.no); });
                    incompleteExacta = Object.values(exactaGroups).find(function (group) { return group.length < 2; });
                    if (incompleteExacta) {
                        modalServiceSubject.next({
                            title: 'Uyarı',
                            content: 'İkili bahis tipinde 2 at seçmelisiniz.',
                            timeout: 3000,
                            confirm: { cancel: { label: 'Tamam' } },
                        });
                        return [2 /*return*/, null];
                    }
                    if (slipItems.length > 1) {
                        price = Number(tjkBetSlipOptions.betSlipMultiply);
                        isExactaPair = tjkFobHorseSelectionTypes.includes(Number((_b = tjkBetSlipOptions.bettingType) === null || _b === void 0 ? void 0 : _b.id)) && slipItems.length === 2;
                        if (isExactaPair) {
                            runNo_1 = Number(String(tjkBetSlipOptions.bettingSubType).split('-')[0]);
                            slipItems = slipItems.filter(function (el) {
                                return Number(el.run.no) === runNo_1 &&
                                    tjkFobHorseSelectionTypes.includes(Number(el.bettingType.id));
                            });
                            slipItems = _.orderBy(slipItems, ['column']);
                            hippodrome = slipItems[0].hippodrome;
                            run = hippodrome.runs.find(function (r) { return Number(r.no) === runNo_1; });
                            oddKey = slipItems[0].horse.no + '-' + slipItems[1].horse.no;
                            if (Number(slipItems[0].bettingType.id) === 1885)
                                oddKey += 'EX';
                            oddId = ((_e = (_d = (_c = run === null || run === void 0 ? void 0 : run.event_odds) === null || _c === void 0 ? void 0 : _c[oddKey]) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.toString()) || '';
                            horseLegs = slipItems.map(function (item) { return [String(item.horse.no)]; });
                            couponData = {
                                betCount: 1,
                                betType: Number(tjkBetSlipOptions.bettingType.id),
                                cardId: hippodrome.card_id,
                                race: String(runNo_1),
                                multiplier: Number(tjkBetSlipOptions.betSlipMultiply),
                                system: false,
                                price: price.toFixed(2),
                                legs: horseLegs,
                                poolUnit: Math.round(Number(tjkBetSlipOptions.bettingType.price) * 100),
                                systemAmount: 5,
                                fob: true,
                                oddRatio: 1,
                                oddId: oddId,
                            };
                        }
                        else {
                            slipItems = _.orderBy(slipItems, [function (e) { return Number(e.run.no); }, 'bettingType.id', 'column'], ['asc']);
                            oddIds = '';
                            _loop_9 = function (i) {
                                hippodrome = slipItems[i].hippodrome;
                                var runNo = Number(slipItems[i].run.no);
                                var run = hippodrome.runs.find(function (r) { return Number(r.no) === runNo; });
                                var horseNo = slipItems[i].horse.no;
                                var typeId = Number(slipItems[i].bettingType.id);
                                var oddId = void 0;
                                if (tjkFobHorseSelectionTypes.includes(typeId)) {
                                    var partnerIdx = slipItems.findIndex(function (el, j) {
                                        return j !== i &&
                                            Number(el.run.no) === runNo &&
                                            Number(el.bettingType.id) === typeId;
                                    });
                                    if (partnerIdx === -1)
                                        return "continue";
                                    if (i > partnerIdx)
                                        return "continue";
                                    var partnerHorseNo = slipItems[partnerIdx].horse.no;
                                    var oddKey = "".concat(horseNo, "-").concat(partnerHorseNo);
                                    if (typeId === 1885)
                                        oddKey += 'EX';
                                    if (typeId === 1884 && !((_f = run === null || run === void 0 ? void 0 : run.event_odds) === null || _f === void 0 ? void 0 : _f[oddKey])) {
                                        oddKey = "".concat(partnerHorseNo, "-").concat(horseNo);
                                    }
                                    oddId = (_j = (_h = (_g = run === null || run === void 0 ? void 0 : run.event_odds) === null || _g === void 0 ? void 0 : _g[oddKey]) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.toString();
                                }
                                else if (typeId === 1886) {
                                    oddId = (_m = (_l = (_k = run === null || run === void 0 ? void 0 : run.event_odds) === null || _k === void 0 ? void 0 : _k["".concat(horseNo, "T2")]) === null || _l === void 0 ? void 0 : _l.id) === null || _m === void 0 ? void 0 : _m.toString();
                                }
                                else if (typeId === 1887) {
                                    oddId = (_q = (_p = (_o = run === null || run === void 0 ? void 0 : run.event_odds) === null || _o === void 0 ? void 0 : _o["".concat(horseNo, "T3")]) === null || _p === void 0 ? void 0 : _p.id) === null || _q === void 0 ? void 0 : _q.toString();
                                }
                                else if (typeId === 1888) {
                                    oddId = (_u = (_t = (_s = run === null || run === void 0 ? void 0 : run.event_odds) === null || _s === void 0 ? void 0 : _s["".concat(horseNo, "T4")]) === null || _t === void 0 ? void 0 : _t.id) === null || _u === void 0 ? void 0 : _u.toString();
                                }
                                else {
                                    oddId = (_x = (_w = (_v = run === null || run === void 0 ? void 0 : run.event_odds) === null || _v === void 0 ? void 0 : _v[Number(horseNo)]) === null || _w === void 0 ? void 0 : _w.id) === null || _x === void 0 ? void 0 : _x.toString();
                                }
                                if (oddId)
                                    oddIds = oddIds ? "".concat(oddIds, "|").concat(oddId) : oddId;
                            };
                            for (i = 0; i < slipItems.length; i++) {
                                _loop_9(i);
                            }
                            hippodrome = slipItems[0].hippodrome;
                            couponData = {
                                betCount: 1,
                                betType: 1883,
                                cardId: hippodrome.card_id,
                                race: String(Number(slipItems[0].run.no)),
                                multiplier: Number(tjkBetSlipOptions.betSlipMultiply),
                                system: false,
                                price: price.toFixed(2),
                                legs: getCouponLegsFromSlipItem(slipItems),
                                poolUnit: Math.round(Number(tjkBetSlipOptions.bettingType.price) * 100),
                                systemAmount: 5,
                                fob: true,
                                oddRatio: 1,
                                oddId: oddIds,
                            };
                        }
                    }
                    else {
                        slipItems = slipItems.filter(function (el) {
                            return !tjkFobHorseSelectionTypes.includes(Number(el.bettingType.id));
                        });
                        if (slipItems.length === 0)
                            return [2 /*return*/, null];
                        slipItem = slipItems[0];
                        price = Number(tjkBetSlipOptions.betSlipMultiply);
                        hippodrome = slipItem.hippodrome;
                        runNo_2 = Number(slipItem.run.no);
                        run = hippodrome.runs.find(function (r) { return Number(r.no) === runNo_2; });
                        horseNo = slipItem.horse.no;
                        typeId = Number(slipItem.bettingType.id);
                        oddKey = Number(horseNo);
                        if (typeId === 1886)
                            oddKey = "".concat(horseNo, "T2");
                        else if (typeId === 1887)
                            oddKey = "".concat(horseNo, "T3");
                        else if (typeId === 1888)
                            oddKey = "".concat(horseNo, "T4");
                        oddEntry = (_y = run === null || run === void 0 ? void 0 : run.event_odds) === null || _y === void 0 ? void 0 : _y[oddKey];
                        isKO = ((_z = oddEntry === null || oddEntry === void 0 ? void 0 : oddEntry.win_odds) === null || _z === void 0 ? void 0 : _z.toString()) === "1.00";
                        couponData = {
                            betCount: 1,
                            betType: isKO ? 1882 : typeId,
                            cardId: hippodrome.card_id,
                            race: String(runNo_2),
                            multiplier: Number(tjkBetSlipOptions.betSlipMultiply),
                            system: false,
                            price: price.toFixed(2),
                            legs: [[String(horseNo)]],
                            poolUnit: Math.round(Number(tjkBetSlipOptions.bettingType.price) * 100),
                            systemAmount: 5,
                            fob: true,
                            oddRatio: ((_0 = oddEntry === null || oddEntry === void 0 ? void 0 : oddEntry.win_odds) === null || _0 === void 0 ? void 0 : _0.toString()) || '0',
                            oddId: ((_1 = oddEntry === null || oddEntry === void 0 ? void 0 : oddEntry.id) === null || _1 === void 0 ? void 0 : _1.toString()) || '',
                        };
                    }
                    return [4 /*yield*/, api
                            .start('post', orderUrl, {
                            token: Storage.get('token'),
                            coupon: JSON.stringify(couponData),
                            unit: tjkBetSlipOptions.usePointBalance ? 2 : 0,
                            complete: tjkBetSlipOptions.complete,
                            save: save,
                            tipster: tjkBetSlipOptions.shareCoupon,
                            device_os: deviceOs,
                            browser_type: 'YENI-WEB',
                            device_type: isMobile ? 'Mobile' : 'Desktop',
                        }, false, 60000)
                            .then(function (result) { return result; })
                            .catch(function (error) {
                            modalServiceSubject.next({
                                title: 'Teknik hata',
                                content: error +
                                    '<p>Kuponunuzun oynanıp oynanmadığını At Yarışı Kuponlarım sayfasından kontrol ediniz.</p>',
                                confirm: {
                                    cancel: {
                                        label: 'At Yarışı Kuponlarım',
                                        action: function () {
                                            window.location.href = '/hesabim/tjk/devam-edenler';
                                        },
                                    },
                                },
                            });
                            return null;
                        })];
                case 1: return [2 /*return*/, _2.sent()];
            }
        });
    });
}
export function PlayTjkLongtermCoupon(save) {
    var _b, _c;
    if (save === void 0) { save = false; }
    return __awaiter(this, void 0, void 0, function () {
        var orderUrl, deviceOs, slipItem, price, hippodrome, horse, dateParts, ddmmyyyy, legKey, couponData;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    orderUrl = env.tjk_api + '/order/api/tjk/place-order/';
                    deviceOs = isAndroid
                        ? 'Android'
                        : isIOS
                            ? 'iOS'
                            : isMacOs
                                ? 'Macintosh'
                                : isWindows
                                    ? 'Windows'
                                    : 'Linux';
                    updateBetCount.status = true;
                    slipItem = tjkBetslipStore.find(function (el) { var _b; return tjkLongtermBettingTypes.includes(Number((_b = el.bettingType) === null || _b === void 0 ? void 0 : _b.id)); });
                    if (!slipItem)
                        return [2 /*return*/, null];
                    price = Number(tjkBetSlipOptions.betSlipMultiply);
                    hippodrome = slipItem.hippodrome;
                    horse = slipItem.horse;
                    dateParts = String(hippodrome._date).split('-');
                    ddmmyyyy = dateParts.length === 3 ? "".concat(dateParts[2]).concat(dateParts[1]).concat(dateParts[0]) : String(hippodrome._date);
                    legKey = "".concat(ddmmyyyy, "-").concat((hippodrome.hippodrome_key || hippodrome.keyword || '').toLowerCase(), "_").concat(slipItem.bettingType.id);
                    couponData = {
                        betCount: 1,
                        betType: Number(slipItem.bettingType.id),
                        cardId: hippodrome._id || hippodrome.id,
                        card: "".concat(ddmmyyyy, "-").concat((hippodrome.hippodrome_key || hippodrome.keyword || '').toLowerCase()),
                        multiplier: price,
                        system: false,
                        price: price.toFixed(2),
                        legs: [(_d = {},
                                _d[legKey] = __assign(__assign({}, horse), { hippodrome: hippodrome.hippodrome }),
                                _d)],
                        poolUnit: Math.round(Number(slipItem.bettingType.price || 1) * 100),
                        systemAmount: 5,
                        fob: true,
                        oddRatio: ((_b = horse.win_odds) === null || _b === void 0 ? void 0 : _b.toString()) || '0',
                        oddId: ((_c = horse.no) === null || _c === void 0 ? void 0 : _c.toString()) || '',
                    };
                    return [4 /*yield*/, api
                            .start('post', orderUrl, {
                            token: Storage.get('token'),
                            coupon: JSON.stringify(couponData),
                            unit: tjkBetSlipOptions.usePointBalance ? 2 : 0,
                            complete: tjkBetSlipOptions.complete,
                            save: save,
                            tipster: tjkBetSlipOptions.shareCoupon,
                            device_os: deviceOs,
                            browser_type: 'YENI-WEB',
                            device_type: isMobile ? 'Mobile' : 'Desktop',
                        }, false, 60000)
                            .then(function (result) { return result; })
                            .catch(function (error) {
                            modalServiceSubject.next({
                                title: 'Teknik hata',
                                content: error +
                                    '<p>Kuponunuzun oynanıp oynanmadığını At Yarışı Kuponlarım sayfasından kontrol ediniz.</p>',
                                confirm: {
                                    cancel: {
                                        label: 'At Yarışı Kuponlarım',
                                        action: function () {
                                            window.location.href = '/hesabim/tjk/devam-edenler';
                                        },
                                    },
                                },
                            });
                            return null;
                        })];
                case 1: return [2 /*return*/, _e.sent()];
            }
        });
    });
}
export function PlayTjkCoupon(save) {
    if (save === void 0) { save = false; }
    return __awaiter(this, void 0, void 0, function () {
        var betCount, price, couponData, orderUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updateBetCount.status = true;
                    betCount = getbetCount();
                    price = Number(tjkBetSlipOptions.betSlipMultiply) *
                        Number(betCount) *
                        Number(tjkBetSlipOptions.bettingType.price);
                    couponData = {
                        betType: tjkBetSlipOptions.bettingType.id,
                        cardId: tjkBetSlipOptions.hippodrome.card_id,
                        race: String(tjkBetSlipOptions.bettingSubType).split('-')[0],
                        multiplier: tjkBetSlipOptions.betSlipMultiply,
                        betCount: betCount,
                        system: tjkBetSlipOptions.system,
                        price: price.toFixed(2),
                        legs: getCouponLegs(),
                        poolUnit: Math.round(Number(tjkBetSlipOptions.bettingType.price) * Number(100)),
                        systemAmount: 5,
                    };
                    orderUrl = env.tjk_api + '/order/api/tjk/place-order/';
                    return [4 /*yield*/, api
                            .start('post', orderUrl, {
                            token: Storage.get('token'),
                            coupon: JSON.stringify(couponData),
                            unit: tjkBetSlipOptions.usePointBalance ? 2 : 0,
                            complete: tjkBetSlipOptions.complete,
                            save: save,
                            tipster: tjkBetSlipOptions.shareCoupon,
                            device_os: isAndroid
                                ? 'Android'
                                : isIOS
                                    ? 'iOS'
                                    : isMacOs
                                        ? 'Macintosh'
                                        : isWindows
                                            ? 'Windows'
                                            : 'Linux',
                            browser_type: 'YENI-WEB',
                            device_type: isMobile ? 'Mobile' : 'Desktop',
                        }, false, 60000)
                            .then(function (result) {
                            return result;
                        })
                            .catch(function (error) {
                            modalServiceSubject.next({
                                title: 'Teknik hata',
                                content: error +
                                    '<p>Kuponunuzun oynanıp oynanmadığını At Yarışı Kuponlarım sayfasından kontrol ediniz.</p>',
                                confirm: {
                                    cancel: {
                                        label: 'At Yarışı Kuponlarım',
                                        action: function () {
                                            window.location.href = '/hesabim/tjk/devam-edenler';
                                        },
                                    },
                                },
                            });
                            return null;
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function clearTjkBetSlip() {
    var slipItem;
    if (tjkBetSlipOptions.bettingType &&
        tjkFobBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) {
        // FOB modunda tüm FOB seçimlerini temizle
        slipItem = tjkBetslipStore.filter(function (el) {
            return tjkFobBettingTypes.includes(Number(el.bettingType.id));
        });
    }
    else if (tjkBetSlipOptions.bettingType &&
        tjkLongtermBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) {
        // Uzun vadeli modunda hipodrom eşleşmesine bakmadan seçimi temizle
        // (tjkBetSlipOptions.hippodrome artık görüntülenen sekmeyi takip ediyor, kupondaki seçimi değil)
        slipItem = tjkBetslipStore.filter(function (el) {
            return tjkLongtermBettingTypes.includes(Number(el.bettingType.id));
        });
    }
    else {
        slipItem = tjkBetslipStore.filter(function (el) {
            if (el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
                el.bettingType.id === tjkBetSlipOptions.bettingType.id &&
                el.bettingSubType === tjkBetSlipOptions.bettingSubType) {
                return el;
            }
        });
    }
    for (var _i = 0, _b = __spreadArray([], slipItem, true); _i < _b.length; _i++) {
        var item = _b[_i];
        tjkBetslipStore.splice(tjkBetslipStore.indexOf(item), 1);
    }
    tjkBetSlipOptions.errorMessage = null;
    tjkBetSlipOptions.betSlipMultiply = (tjkFobBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id)) ||
        tjkLongtermBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id))) ? 20 : 1;
    tjkBetSlipOptions.usePointBalance = false;
    tjkBetSlipOptions.shareCoupon = false;
    tjkBetSlipOptions.complete = false;
    updateBetCount.status = true;
    Storage.set('betSlip', tjkBetslipStore);
    tjkBetSlipActionSubject.next({ action: 'clear', data: null });
}
